import React, { useEffect, useState } from 'react';
import Grid from '../../../Grid';
import styles from './Cards.module.sass';
import { openMetricsExport, countsUrl, EXPORT_SCHOOL_CHANGED } from '../../../../utils/exportSchoolFilter';

const Cards = () => {
  const [counts, setCounts] = useState([]);
  // '' = all schools. ExportSchoolFilter is a separate React root, so the
  // selection arrives as a DOM event rather than a prop.
  const [schoolId, setSchoolId] = useState('');

  useEffect(() => {
    const handleSchoolChange = (e) => setSchoolId((e.detail && e.detail.schoolId) || '');

    document.addEventListener(EXPORT_SCHOOL_CHANGED, handleSchoolChange);
    return () => document.removeEventListener(EXPORT_SCHOOL_CHANGED, handleSchoolChange);
  }, [])

  useEffect(() => {
    let active = true;

    const fetchPackages = async () => {
      let response = await fetch(countsUrl('/api/v1/orders/order_package_counts', schoolId))
      response = await response.json()
      if (active) setCounts(response.data)
    }

    fetchPackages();
    return () => { active = false; };
  }, [schoolId])

  return (
    <div className={styles.cardsContainer}>
      <Grid container>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=ready_for_export&scope=school_portraits&mark_as_exported=true&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.ready_for_export}
          </a>
          <p className={styles.cardInfo}>
            Items that are ready to be exported
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=not_yet_shipped&scope=school_portraits&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.not_yet_shipped}
          </a>
          <p className={styles.cardInfo}>
            Items that have been exported but not shipped
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=shipped_24_hours&scope=school_portraits"
             onClick={openMetricsExport}>
            {counts && counts.shipped_24_hours}
          </a>
          <p className={styles.cardInfo}>
            Items that have been shipped in the last 24 hours
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=missing_images&scope=school_portraits"
             onClick={openMetricsExport}>
            {counts && counts.missing_images}
          </a>
          <p className={styles.cardInfo}>
            Items that need images synced before they can be exported
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=reprint&scope=school_portraits&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.reprint}
          </a>
          <p className={styles.cardInfo}>
            Items marked as reprint
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=on_hold&scope=school_portraits&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.on_hold}
          </a>
          <p className={styles.cardInfo}>
            Items on hold
          </p>
        </Grid>
      </Grid>
      <Grid container>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=work_order_packages&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.work_orders}
          </a>
          <p className={styles.cardInfo}>
            Work orders ready to print
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default Cards
